'use client'

import { useChannelPresence } from '@/hooks/navigation/useChannelPresence'
import { ChannelPresenceAvatars, type TamanhoDosAvatares } from './index'

/** Liga quem está no canal ao componente puro. Sem o gate triplo a lista vem vazia e nada renderiza. */
export function ChannelPresence({
  channelId,
  size,
  className,
}: {
  channelId: string
  size?: TamanhoDosAvatares
  className?: string
}) {
  const lista = useChannelPresence(channelId)
  return <ChannelPresenceAvatars lista={lista} size={size} className={className} />
}
